import api from "api";
import { IAddDistrictBody, IUpdateDistrictBody } from "types/district";
import { IPaginationQueryParams } from "types/shared";

const getDistricts = ({ sortBy, pageIndex, pageSize}: IPaginationQueryParams) => 
api.get(`/district/getDistricts?sortBy=${sortBy}&pageSize=${pageSize}&pageIndex=${pageIndex}`)

const addDistrict = (data: IAddDistrictBody) => api.post("/district/addDistrict", data)

const udpateDistrict = (data: IUpdateDistrictBody) => api.put("/district/updateDistrict", data)

const deleteDistrict = (districtId: number) => api.delete(`district/deleteDistrict/${districtId}`)

export default { getDistricts, addDistrict, udpateDistrict, deleteDistrict }